import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { ItemScopeToolbar } from '@app/purchased-goods/components/item-detail/item-scope-toolbar';
import { useItemScope } from '@app/purchased-goods/components/item-detail/use-item-scope';
import { useGetPurchasedFoodAndDrinkItemInsights } from '@shared/api/hooks/purchased-goods/item-insights';
import { Icons } from '@shared/components/content/icons';
import { PageTabs } from '@shared/components/page-tabs';
import { Button } from '@shared/components/ui/button';
import { generatePath, Outlet, useNavigate } from 'react-router-dom';
import { purchasedGoodsRoutes } from '../purchased-goods-routes';
import { getFoodReferrerLabel } from '../utils';
import { usePurchasedFoodAndDrinkItem } from './purchased-food-and-drink-item-context';
import { usePurchasedFoodAndDrinkItemsTabs } from './tabs';

export default function PurchasedFoodAndDrinkItemLayout() {
  const { item, status, referrer, foodActivityUuid } =
    usePurchasedFoodAndDrinkItem();
  const tabs = usePurchasedFoodAndDrinkItemsTabs();
  const navigate = useNavigate();
  const { insightsParams } = useItemScope();
  const { data: insights } = useGetPurchasedFoodAndDrinkItemInsights(
    foodActivityUuid ?? '',
    insightsParams
  );

  return (
    <Page
      name={item?.purchasedGood.name}
      page="layout"
      status={status}
      title={`${item?.purchasedGood.name} - Purchased Food and Drink`}
      flexFullHeight
    >
      <PageHeader
        name={item?.purchasedGood.name}
        tabs={<PageTabs tabs={tabs} />}
        breadcrumbs={[
          {
            label: 'Purchased goods',
            url: generatePath(purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK),
          },
          {
            label: 'Food and drink',
            url: generatePath(purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK),
          },
          {
            label: item?.purchasedGood.name || 'Item',
            url: generatePath(
              purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK_ITEM,
              {
                item_uuid: item?.purchasedGood.uuid || '',
              }
            ),
          },
        ]}
        toolbar={
          <div className="flex flex-wrap items-center justify-end gap-2">
            {referrer ? (
              <Button
                variant="ghost"
                onClick={() => navigate(referrer)}
                icon={<Icons.chevronLeft className="size-4" />}
              >
                {getFoodReferrerLabel(referrer)}
              </Button>
            ) : null}
            <ItemScopeToolbar
              defaultStart={insights?.timePeriodStart}
              defaultEnd={insights?.timePeriodEnd}
              siteOptions={insights?.availableFilters.sites}
            />
          </div>
        }
      />
      <Outlet />
    </Page>
  );
}
